import { render, staticRenderFns } from "./AddedWallBlockItem.vue?vue&type=template&id=a7d2f354"
import script from "./AddedWallBlockItem.vue?vue&type=script&lang=js"
export * from "./AddedWallBlockItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports